// Fix D (2026-08-24): cuando el dueño reinicia el sistema, cada dispositivo
// descarta su copia local en silencio (ver pullChanges() en lib/sync.js) —
// este aviso es la única señal visible de que eso pasó, mostrado una sola vez.
import { useEffect, useRef } from "react";
import { onSyncState } from "@/lib/sync";
import { toast } from "sonner";

export function SystemResetNotice() {
  const lastAt = useRef(null);
  useEffect(() => {
    const off = onSyncState((s) => {
      const resetDetected = s.phase === "idle" ? s.last?.pull?.resetDetected : false;
      if (resetDetected && s.last.at !== lastAt.current) {
        lastAt.current = s.last.at;
        toast.info("El sistema fue reiniciado por el dueño. Se descargaron los datos actualizados.", { duration: 8000 });
      }
    });
    return off;
  }, []);
  return null;
}
